import type { RefCallback } from 'react';
import type {
  ControllerRenderProps,
  FieldValues,
  UseFormRegisterReturn,
} from 'react-hook-form';

export const withMaskitoRegister = (
  registerResult: UseFormRegisterReturn,
  maskitoRef: RefCallback<HTMLElement | null>
): UseFormRegisterReturn & { onInput: UseFormRegisterReturn['onChange'] } => {
  const ref: RefCallback<HTMLElement | null> = (node): void => {
    registerResult.ref(node);
    maskitoRef(node);
  };

  return {
    ...registerResult,
    ref,
    onInput: registerResult.onChange,
    onChange: registerResult.onChange,
  };
};

export function withMaskitoField<T extends FieldValues>(
  field: ControllerRenderProps<T>,
  maskitoRef: RefCallback<HTMLElement | null>
): ControllerRenderProps & { onInput: ControllerRenderProps['onChange'] } {
  const ref: RefCallback<HTMLElement | null> = (node): void => {
    field.ref(node);
    maskitoRef(node);
  };

  return {
    ...field,
    ref,
    onInput: field.onChange,
    onChange: field.onChange,
  };
}
